import { render, staticRenderFns } from "./ClaimDNSContainer.vue?vue&type=template&id=fcb3ab18&scoped=true&lang=html&"
import script from "./ClaimDNSContainer.vue?vue&type=script&lang=js&"
export * from "./ClaimDNSContainer.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDNSContainer.vue?vue&type=style&index=0&id=fcb3ab18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb3ab18",
  null
  
)

export default component.exports